import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'EventListItemSkeleton',
  values: {
    isAmericanEvent: false,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    eventTime: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '24px',
          height: '11px',
        },
      },
    },
    participantsAndMarketsContainer: {
      configSet: FlexPane,
      configValues: {
        _desktop_itemSpacing: '8px',
        style: {
          justifyContent: 'space-between',
          flexGrow: 0,
          padding: '2px 0',
        },
      },
    },
    participantsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'space-evenly',
        },
      },
    },
    participant: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '104px',
          height: '14px',
        },
      },
    },
    marketContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          _desktop_width: '176px',
          flexGrow: 0,
        },
      },
    },
    selection: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '60px',
          height: '45px',
          _desktop_width: '100%',
        },
      },
    },
    marketCount: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '16px',
          height: '11px',
        },
      },
    },
    americanParticipantsAndMarketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 0,
          padding: '2px 0 0 0',
        },
      },
    },
    americanParticipantContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      },
    },
    americanMarketsContainer: {
      configSet: FlexPane,
      configValues: {
        _desktop_itemSpacing: '8px',
        style: {
          flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
